<script>
    export let pirate;
    export let ines;
    export let lang = 'pl';
    import { texts } from './texts.js';
</script>

<div class="end-score">
    <div>
        <img src="build/img/inez-nobg.png" class="end-score-ikon" alt="ines" />
        <img
            src="build/img/korsarz-nobg.png"
            class="end-score-ikon"
            alt="pirate"
        />
    </div>
    <h3>
        {texts[lang].ines_earned}{ines}
        {texts[lang].gold} <i class="fas fa-coins" />
    </h3>
    <h3>
        {texts[lang].pirate_earned}
        {pirate}
        {texts[lang].gold} <i class="fas fa-coins" />
    </h3>
</div>
